import React, { useEffect, useState } from "react";
import { CameraIcon, CloseIcon, DownChevronIcon, DownloadIcon, InfoIcon, SendIcon } from "../Svg";
import { Button } from "../Button";
import _ from "lodash";
import { TextInput } from "../form/TextInput";
import cx from "classnames";
import Tooltip from "../Tooltip";
import { AIShowcase } from "../../store/models/AIShowcase";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { ModalTypes, PredictionStatus, Urls } from "../../constants";
import Loader from "../Loader";
import UIState, { selectMobileLayout } from "../../store/UIState";
import { createSelector } from "reselect";
import { AiOndemandApi, PREDICTION_STARTED, PREDICTION_STOPPED, selectApiKeys, selectPredictionId, selectPredictionStatus } from "../../store/models/AiOndemandApi";
import { getOndemandErrorMsg, readFileAsDataURL, extractErrorText } from "../../utils";
import { AudioInput } from "../form/AudioInput";
import { selectCurrentUser } from "../../store/models/User";


const ChatMessage = ({ message, showcaseModelUrl, mName }) => {

  const audioUrl = !mName
    ? `${showcaseModelUrl}/file=${message.audio.path}`
    : `${message.audio.path}`;

  return (
    <div className={cx("UserMessageContainer")}>
      <div className="UserMessage">
        <div className={"UserMessage__PromptLabel"}>Source audio</div>
        <div className={"UserMessage__PromptValue"}>
          <audio controls>
            <source src={audioUrl} type="audio/mpeg" />
            Your browser does not support the audio element.
          </audio>
        </div>
      </div>

    </div>)
}

const TextItem = ({ item }) => {
  return (
    <div className={cx("ResultBox")}>
      <div className={"ResultBox__Text"}>
        <div className={"ResultBox__Text--label"}>
          Transcription complete. Here is the result:
        </div>
        "{item.text}"
      </div>
    </div>
  )
}

const TextLoadingItem = ({ loadingData, elapsedTime, predictionStatus }) => {
  const isLoadingPrediction = predictionStatus === PredictionStatus.IN_PROGRESS
    || predictionStatus === PredictionStatus.STARTED;
  if (!loadingData && !isLoadingPrediction) return <></>;

  if (loadingData && loadingData.msg === 'estimation') {
    return (
      <div className={cx("ResultBox")}>
        <div className={"ResultBox__Loading"}>
          <div className={"ResultBox__Loading__TopWrapper"}>
            Scheduled | {elapsedTime}s / {loadingData?.rank_eta?.toFixed(0) ?? '?'}s
          </div>

          <div className={"ResultBox__Loading__CenterWrapper"}>
            <Loader size={"small"} color={"green"} /> Waiting for available slot...
          </div>

          <div className={"ResultBox__Loading__BottomWrapper"}>Number of jobs ahead of you: <span
            style={{ color: '#ffffff' }}>{loadingData.rank + 1}</span></div>
        </div>
      </div>)
  }

  if ((loadingData && loadingData.msg === 'process_starts')
    || isLoadingPrediction) {
    return (<div className={cx("ResultBox")}>

      <div className={"ResultBox__Loading"}>

        <div className={"ResultBox__Loading__TopWrapper"}>
          Processing | {elapsedTime}s / {loadingData?.eta?.toFixed(0) ?? '?'}s
        </div>

        <div className={"ResultBox__Loading__CenterWrapper"}>
          <Loader color={"green"} />
        </div>

        <div className={"ResultBox__Loading__BottomWrapper"}>Audio transcription in progress...</div>
      </div>
    </div>)
  }
}

const selector = createSelector(
  selectMobileLayout,
  selectApiKeys,
  selectPredictionStatus,
  selectPredictionId,
  selectCurrentUser,
  (isMobile, apiKeys, predictionStatus, predictionId, curUser) => ({
    isMobile,
    apiKeys,
    predictionStatus,
    predictionId,
    curUser
  }
  ))

let showcaseAudioToTextIntervalId = null;

export const ShowcaseAudioToText = ({ showcase, mName = null, className }) => {

  const dispatch = useDispatch();

  const {
    isMobile,
    apiKeys,
    predictionStatus,
    predictionId,
    curUser
  } = useSelector(state => selector(state));
  const apiKey = _.get(apiKeys, '0.key');
  const [loadingData, setLoadingData] = useState(null);
  const [audioUploading, setAudioUploading] = useState(false);
  const [error, setError] = useState(null);
  const [elapsedTime, setElapsedTime] = useState(0);
  const [currentAudio, setCurrentAudio] = useState(null);
  const [messages, setMessages] = useState([]);
  const chatboxRef = React.createRef();
  const showcaseModel = showcase?.models?.[0];
  const showcaseModelUrl = showcaseModel?.urls;
  const audioUrl = currentAudio
    ? (!mName
      ? `${showcaseModelUrl}/file=${currentAudio.path}`
      : `${currentAudio.path}`)
    : null;
  const [currentAudioFile, setCurrentAudioFile] = useState()


  useEffect(() => {
    if (predictionStatus !== PredictionStatus.STOPPED) {
      dispatch({ type: PREDICTION_STOPPED });
    }
    return () => {
      if (showcaseAudioToTextIntervalId) {
        clearInterval(showcaseAudioToTextIntervalId)
      }
      //showcase usage
      //dispatch(AIShowcase.actions.stopAudioToVideoGeneration())
    }
  }, []);

  // useEffect(() => {
  //   return async () => {
  //     if (predictionId) {
  //       try {
  //         await dispatch(AiOndemandApi.actions.stopHostedPredict(predictionId, apiKey));
  //       } catch (e) {
  //         console.log('Error when cancelling the prediction:', e.message);
  //       }
  //     }
  //   }
  // }, [predictionId]);

  const onTranscribe = async (event) => {
    setError(null)
    event.preventDefault();

    try {
      setMessages([...messages, { type: 'prompt', audio: currentAudio }, { type: 'loading' }])
      onScrollToBottom()
      if (!mName) {
        //showcase template
      } else {
        await onHostedTranscribeAudio();
      }
    } catch (e) {
      toast.error(e.message)
      console.error(e)
    }
  };

  const onHostedTranscribeAudio = async () => {
    console.log('currentAudioFile:', currentAudioFile);
    dispatch({ type: PREDICTION_STARTED });
    startStopwatch()
    let audioPresignedUrl = {};

    try {
      await fetchPreSignUrl();
      await dispatch(AiOndemandApi.actions.uploadImageToBucket(currentAudioFile, _.get(audioPresignedUrl, `presigned_url`)));

      onRemoveAudio();
      const params = {
        "audio_filename": audioPresignedUrl.filename,
      };

      let res = await dispatch(AiOndemandApi.actions.startHostedPredict(params, mName, apiKey));
      console.log('startHostedPredict res:', res)
      const outputText = _.get(res, 'body.infer_requests.0.output.text');
      if (outputText) {
        setLoadingData(null)
        stopInterval()
        setMessages((messages) => [...messages.slice(0, -1), { type: 'result', text: outputText }])
        onScrollToBottom();
      } else if (res) {
        const errMsg = _.get(res, 'body.infer_requests.0.error_message');
        onError(errMsg === 'null' ? null : errMsg);
      }
    } catch (e) {
      dispatch({ type: PREDICTION_STOPPED });
      onError(getOndemandErrorMsg(e.message, curUser));
    }

    async function fetchPreSignUrl() {
      if (!mName || !apiKey) return;
      let res = await dispatch(AiOndemandApi.actions.presignUrl('whisper', null, apiKey));
      audioPresignedUrl = _.get(res, "audio_filename");
    }
  }

  const onAudioSelected = async (file) => {
    if (!file) return;

    try {
      setAudioUploading(true)
      let audioPath = '';
      if (!mName) {
        //showcase template
      } else {
        audioPath = await readFileAsDataURL(file);
        setCurrentAudioFile(file)
      }
      setAudioUploading(false)
      const audioData = {
        "meta": {
          "_type": "gradio.FileData"
        },
        "mime_type": file.type,
        "orig_name": file.name,
        "path": audioPath,
        "size": file.size,
      }

      console.log('audioData:', audioData)

      setCurrentAudio(audioData)
    } catch (e) {
      setAudioUploading(false);
      toast.error("Failed to upload audio");
    }
  }

  const onRemoveAudio = () => {
    setCurrentAudio(null)
  }

  const onError = (error) => {
    setLoadingData(null)
    setMessages((messages) => messages.slice(0, -2))
    stopInterval()
    setError(error ?? "Failed to generate video. Try again later")
    error = extractErrorText(error);
    toast.error(error ?? "Failed to generate video. Try again later")
  }

  const startStopwatch = () => {

    if (showcaseAudioToTextIntervalId) {
      stopInterval()
    }

    const startTime = new Date().getTime()

    showcaseAudioToTextIntervalId = setInterval(() => {
      const currentTime = new Date().getTime()
      setElapsedTime(((currentTime - startTime) / 1000).toFixed(0))
    }, 1000)

  }

  const stopInterval = () => {
    clearInterval(showcaseAudioToTextIntervalId)
    showcaseAudioToTextIntervalId = null
    setElapsedTime(0)
  }

  const onStopTranscribing = (event) => {
    event.preventDefault();

    dispatch(UIState.actions.showModal(ModalTypes.CONFIRM, {
      title: "Stop generating",
      message: "Are you sure you want to stop the ongoing audio transcribing?",
      onConfirm: onConfirmStopTranscribing,
      confirmLabel: "Yes",
      cancelLabel: "No",
      size: 's'
    }))
  }

  const onConfirmStopTranscribing = () => {
    stopInterval()
    setLoadingData(null)
    setMessages((messages) => messages.slice(0, -2))
    if (mName) {
      dispatch(AiOndemandApi.actions.stopHostedPredict(predictionId, apiKey));
    } else {
      //showcase template
    }
  }

  const onScrollToBottom = () => {
    if (!isMobile) {
      setTimeout(() => {
        window.scrollTo(0, document.body.scrollHeight);
        if (!_.isNil(chatboxRef) && !_.isNil(chatboxRef.current)) {
          chatboxRef.current.scrollTop = chatboxRef.current.scrollHeight;
        }
      }, 200)
    }
  }

  return (
    <div className={cx("ShowcaseAudioToText", className)}>
      <div className="ShowcaseAudioToText__container">
        <div className={"ShowcaseAudioToText__LeftSide"}>
          {!isMobile && <div className={"ShowcaseAudioToText__Title"}>{"Model: Whisper"}</div>}

          <div className={"SidePanel"}>

            <form className="SidePanel__form">

              <AudioInput
                name={"audio"}
                value={audioUrl}
                onChange={onAudioSelected}
                onRemove={onRemoveAudio}
                formats={'audio/*'}
                displayName={currentAudioFile?.name}
              />

              <div className={"SidePanel__ActionButtons"}>
                <Button
                  title={"Clear"}
                  color={"grey"}
                  className="SidePanel__ActionButtons__Button"
                  disabled={_.isNil(currentAudio)}
                  onClick={onRemoveAudio}
                />

                {(loadingData || predictionStatus === PredictionStatus.IN_PROGRESS)
                  ? <Button
                    title={"Stop generating"}
                    onClick={onStopTranscribing}
                    className="SidePanel__ActionButtons__Button"
                    color={"red"}
                  />
                  : <Button
                    title={"Send"}
                    onClick={onTranscribe}
                    icon={audioUploading ? null : <SendIcon />}
                    className="SidePanel__ActionButtons__Button"
                    color={"green"}
                    loading={audioUploading}
                    disabled={!_.isNil(loadingData) || _.isNil(currentAudio)
                      || predictionStatus === PredictionStatus.STARTED} />}
              </div>
            </form>

          </div>
        </div>

        <div className={cx("ShowcaseAudioToText__RightSide")}>
          {error && <div className={"ErrorMessage"}>{error}</div>}

          {!_.isEmpty(messages) && <div className={"MessagesWrapper"} ref={chatboxRef}>
            {messages.map((item, index) => {
              console.log('item:', item)
              switch (item.type) {
                case 'prompt':
                  return (<ChatMessage key={index} message={item} showcaseModelUrl={showcaseModelUrl} mName={mName} />)
                case 'loading':
                  return (<TextLoadingItem key={index} loadingData={loadingData} elapsedTime={elapsedTime} predictionStatus={predictionStatus} />)
                case 'result':
                  return (<TextItem key={index} item={item} />)
              }
            })}
          </div>
          }

        </div>
      </div>

    </div>
  );
}